"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierSchemaProperties = exports.TierSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const package_schema_1 = require("./package-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const TierContent = zod_1.z.object({
    type: zod_1.z.enum(["time", "sessions"]),
    quantity: zod_1.z.number(),
    unit: zod_1.z.enum(["minutes", "hours", "unit"]),
    period: zod_1.z.enum(["months", "weeks", "years"]),
    schedulers: zod_1.z.array(zod_1.z.string()),
    unlimitedSchedulerIds: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.TierSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string().default("No title"),
    icon: zod_1.z
        .object({
        url: zod_1.z.string(),
        fileName: zod_1.z.string(),
        size: zod_1.z.number(),
        contentType: zod_1.z.string(),
        fullPath: zod_1.z.string().optional(),
        bucket: zod_1.z.string().optional(),
        extension: zod_1.z.string().optional(),
    })
        .optional()
        .nullable(),
    description: zod_1.z.string().optional(),
    itemizations: zod_1.z.array(zod_1.z.string()).optional().nullable(),
    packageTemplateId: zod_1.z.string(),
    content: TierContent,
    isPopular: zod_1.z.boolean(),
    onTrackNotifications: package_schema_1.OnTrackNotificationsType.optional().nullable(),
    onTrackRules: package_schema_1.PackageOnTrackRulesType.optional().nullable(),
    order: zod_1.z.number().optional(),
    serviceFee: package_schema_1.ServiceFee.optional().nullable(),
    hideFromBookingFlow: zod_1.z.boolean().optional(),
});
exports.TierSchemaProperties = {
    collectionName: "tiers",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=tier-schema.js.map